import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AuthService } from 'src/services/auth.service';
import { BusinessApiService } from 'src/services/business_api.service';
import { IonicModule } from '@ionic/angular';
import { UploadAPIService } from 'src/services/upload_api.service';
import { CategoryApiService } from 'src/services/category_api.service';
import { BusinessStaffApiService } from 'src/services/business_staff_api.service';
import { MembershipApiService } from 'src/services/membership_api.service';
import { CouponApiService } from 'src/services/coupon_api.service';
import { CustomerApiService } from 'src/services/customer_api.service';
import { AdvertisementApiService } from 'src/services/advertisement_api.service';
import { BannerApiService } from 'src/services/banner_api.service';
import { GpsApiService } from 'src/services/gps_api.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateConfigService } from '../translate-config.service';
import { HttpClient } from '@angular/common/http';
import { AccessRoleAPIService } from 'src/services/accessRole_api.service';
import { CouponPreviewComponent } from './coupon-preview/coupon-preview.component';

export function LanguageLoader(http: HttpClient) {
  return new TranslateHttpLoader();
}
@NgModule({
  exports: [],
  imports: [HttpClientModule,CouponPreviewComponent,IonicModule,TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: LanguageLoader,
        deps: [HttpClient],
      },
    }),],
  providers: [AuthService,BusinessApiService,UploadAPIService,CategoryApiService,BusinessStaffApiService,MembershipApiService,CouponApiService,CustomerApiService,AdvertisementApiService,BannerApiService,GpsApiService,TranslateConfigService,AccessRoleAPIService]
})

export class SharedModule {}